import apiTransaction from '@/api/ecommerce/transaction';
// import apiOption from '@/api/option';

const defaultState = () => ({
	listData: [],
	paginationData: '',
	detailTransaction: {},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setData(state, data) {
		state.listData = data.data
		state.paginationData = data.pagination;
	},
	setDetailTransaction(state, data) {
		state.detailTransaction = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataTransaction(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getTransaction({ commit, dispatch }, params) {
		apiTransaction.getDataTransaction(params).then(({ data: { data } }) => {
			commit('setData', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setData', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportTransaction({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTransaction.exportTransaction(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Transaksi'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getDetailTransaction({ commit, dispatch }, params) {
		apiTransaction.getDetailTransaction(params).then(({ data: { data } }) => {
			commit('setDetailTransaction', data);
		}).catch((err) => {
			commit('setDetailTransaction', {});
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	getStatusListTransaction({ dispatch }) {
		return new Promise((resolve) => {
			apiTransaction.getStatusListTransaction().then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
			});
		})
	},
	getBankTransfer({ commit, dispatch }, params) {
		apiTransaction.getDataBankTransfer(params).then(({ data: { data } }) => {
			commit('setData', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setData', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportBankTransfer({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTransaction.exportBankTransfer(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Transfer Bank'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getBankTransferCancel({ commit, dispatch }, params) {
		apiTransaction.getDataBankTransferCancel(params).then(({ data: { data } }) => {
			commit('setData', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setData', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportBankTransferCancel({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTransaction.exportBankTransferCancel(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Pembatalan Transfer Bank'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	approvalTransfer({ dispatch }, params) {
		return new Promise(async (resolve, reject) => {
			await dispatch('isAttempting', null, { root: true })
			await apiTransaction.approvalTransfer(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
			await dispatch('attempted', null, { root: true })
		})
	},
	cancelApprovalTransfer({ dispatch }, params) {
		return new Promise(async (resolve, reject) => {
			await dispatch('isAttempting', null, { root: true })
			await apiTransaction.cancelApprovalTransfer(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
			await dispatch('attempted', null, { root: true })
		})
	},
	sendEmailSerial({ dispatch }, params) {
		return new Promise(async (resolve, reject) => {
			await dispatch('isAttempting', null, { root: true })
			await apiTransaction.sendEmailSerial(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
			await dispatch('attempted', null, { root: true })
		})
	},
	getTransactionCash({ commit, dispatch }, params) {
		apiTransaction.getTransactionCash(params).then(({ data: { data } }) => {
			commit('setData', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setData', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportTransactionCash({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTransaction.exportTransactionCash(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Transaksi Cash'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},

	getTransactionVA({ commit, dispatch }, params) {
		apiTransaction.getTransactionVA(params).then(({ data: { data } }) => {
			commit('setData', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setData', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportTransactionVA({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiTransaction.exportTransactionVA(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Transaksi VA'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};